import React, { useContext, useState , useEffect, useRef}  from 'react';
import { Box, Typography, Modal, Button } from '@mui/material'
import ExceptionalFormQuestions from './exeptionalformquestions';
import reportUtils from '../../../../utilities/report/reportutils';
import ExtraFormQuestionsModal from '../extra form questions/ExtraFormQuestionsModal';
import exceptionalRefStoryBuilder from '../../../../utilities/Story/exceptionalRefStoryBuilder';
import { SymptomDetailsContext } from '../../../../utilities/context';
import '../../../../css/report.css'
import { Formik, Form, Field } from 'formik';

function ExceptionalFormQuestionsModal(props){

  const style={
    position: 'absolute',
    top: '50%',
    left: {xs:"37%", sm:"30%"},
    transform: 'translate(-30%, -50%)',
    flex: {xs:"50%", sm:"90%"},
    display:"flex block",
    maxHeight:"90%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow:"scroll"
    };

const {story, setStory, rdc, setRdc, exceptionalRefDetails, setExeptionalRefDetails } = useContext(SymptomDetailsContext)
const [formValues, setFormValues] = useState()
const [efcModalOpen, setEfcModalOpen] = useState(false)
const [efcHasBeenOpened, setEfcHasBeenOpened]=useState(false)
const [storyEditorBoxOpen, setStoryEditorBoxOpen] = useState(false)
const [storyInitialValues, setStoryInitialValues] = useState()
const [selectedPathway, setSelectedPathway] = useState()
const [pathLabel, setPathLabel]= useState()
const [formSubmitted, setFormSubmitted] = useState(false)
const storyRef =useRef()

useEffect(()=>{
  if (formValues !== undefined)
    {
    setSelectedPathway(formValues.Which_RDC_clinic_do_you_want_to_refer_to)
    let label=reportUtils.getPathLabel(formValues.Which_RDC_clinic_do_you_want_to_refer_to)
    setPathLabel(label)
    let exceptionalReferralStory=exceptionalRefStoryBuilder(formValues) 
    let initialStory=""
    if (story !== undefined)
      {
      initialStory=story + exceptionalReferralStory
      }
    else 
      {
      initialStory=exceptionalReferralStory
      }
      setStoryInitialValues({"storyText": initialStory})
    }
}, [formValues])

useEffect(()=>{
  if (storyInitialValues !== undefined)
    { 
    setStoryEditorBoxOpen(true)
    }
  },[storyInitialValues])

  useEffect(()=>{ 
    if (storyEditorBoxOpen)
    {
    storyRef.current.scrollIntoView({ behavior: 'smooth' })
}},[storyEditorBoxOpen])

const handleClose =()=> 
  {
  props.setModalOpen(false)
  }

const onSubmit=(values)=>
  {
  setStory(values.storyText)
  
  setEfcModalOpen(true)
  setEfcHasBeenOpened(true)// prevents useEffect below closing Modal before extraformQuestions has opened
  }

  useEffect((values)=>{
    if (formSubmitted)
      { 
        rdc.push(selectedPathway)
        setRdc(rdc)
        let updatedExceptionalRef = exceptionalRefDetails.push(values)
        setExeptionalRefDetails(updatedExceptionalRef)
      }
    },[formSubmitted])//checks that question form has been submitted before completing clinc order







useEffect(()=>{
  if (efcHasBeenOpened && !efcModalOpen)
    {
    handleClose()
    }
},[efcModalOpen])
//closes modal only after extraForQuestions Modal has been closed

return(<Modal
  open={props.modalOpen}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
  If you have reason to make an urgent RDC referral that is not covered by NG12 referral guidelines, please document this here. If you are not sure if RDC referral is needed, consider making an Advice and Guidance request.
    </Typography>
  
   <Box sx={{m:2}}>
    <ExceptionalFormQuestions setModalOpen={props.setModalOpen} setFormValues={setFormValues} />
  </Box>

  <Box className={(storyEditorBoxOpen ? "modalInputBox" : "hidden")}>
  <Formik
    enableReinitialize
    initialValues={storyInitialValues}
    onSubmit={onSubmit}
    >
      
   <Form >
    <Box sx={{border:"solid", borderColor:"grey.300",borderRadius:"10px", width:"auto", margin:1}}>
    <label htmlFor={"storyText"}> {"History"} </label>
    <p><Field as = 'textarea'className="textAreaInputBox" id={"storyText"}  name={"storyText"} /></p>
    </Box>
     <Button  ref={storyRef} sx={{ m: 1 }} variant='contained' size="small" type='submit' >Save Story and make {selectedPathway} referral
</Button>
    </Form>
  </Formik>
  </Box>
  <ExtraFormQuestionsModal modalOpen={efcModalOpen}  setModalOpen={setEfcModalOpen} path={pathLabel} pathwayType={"rdc"} setFormSubmitted={setFormSubmitted}/>
  </Box>

</Modal>)
}

export default ExceptionalFormQuestionsModal